import React, { useEffect, useContext} from 'react'
import { StateController } from '../../App'

import VerticalCenter from '../../layouts/VerticalCenter/VerticalCenter'
import Button from '../atoms/Button'
import Icon from '../atoms/Icon'

function MechanicModal({
  show,
  setShowModal,
  segment,
}) {
  const { setMdalOpen } = useContext(StateController)

  useEffect(() => {
    setMdalOpen(show);
    
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  const close = () => {
    setShowModal(false)
  }

  const slidesSteps = [
    {  
      title: 'Cumple tus metas ',
      number: '1',
      desc: `Tendrás dos metas. Una de compras en <b>almacenes ${segment}</b> y otra en <b>otros comercios.</b> Al cumplirlas, participas por los premios.`,
    },
    { 
      title: '¡Gana uno de los 70 premios!',
      number: '2',
      desc: 'Quien más compras realice en otros comercios <b>gana un Renault Kwid 0 km.</b> Los otros lugares se llevan premios increíbles.',
    },
  ]
  
  return (
    <div className={`mc-mechanic-modal ${show && 'mc-mechanic-modal__opened'} slow_ani`}>
      <div className="mc-mechanic-modal__overlay slow_ani" onClick={close}></div>
      <div className="mc-mechanic-modal__center">
        <VerticalCenter>
          <div className="mc-mechanic-modal__close" onClick={close}>
            <Icon name="close" />
          </div>
          <div className={`mc-mechanic-modal__center--window slow_ani`}>
          {/* <img src='/assets/images/confeti_mechanic_modal.png' className='confeti_izq' alt='confeti_izq'/> */}
            <div>
              <div className={`mc-mechanic-modal__center--window__title`}>
                <p>¿Cómo ganar?</p>
              </div>
              <div className={`mc-mechanic-modal__center--window__subtitle`}>
                <p><b>Paga todas tus compras con tu Tarjeta {segment} Mastercard</b> del 15 de abril al 15 de junio de 2026.</p>
              </div>
              <h5>
                Paso a paso
              </h5>
              <div className={`mc-mechanic-modal__center--window__desc`}>
                {slidesSteps.map((step, index) => {   
                  return (
                    <div key={index} className={`participar-steps__items--item`}>
                      <div className='participar-steps__items--item--desc'>
                        <div className='participar-steps__items--item--image'>
                          <span>{step.number}</span>
                        </div>
                        <div className='participar-steps__items--item--text'>
                          <h6>
                            {step.title}
                          </h6>
                          <p dangerouslySetInnerHTML={{ __html: step.desc}} />
                        </div>
                      </div>
                    </div>
                  )  
                })}
              </div>
            </div>
            <div className={`mc-mechanic-modal__center--window__actions`}>
              <Button
                type="secondary"
                text={'Cerrar'}
                loading={false}
                status="active"
                onClick={close}
              />
            </div>
          </div>
        </VerticalCenter>
      </div>
    </div>
  )
}

export default MechanicModal